export enum PackagePanelEvents {
  OnPackagePanelClose = 'packagePanelEventClose',
  OnPackagePanelMaybeClose = 'packagePanelEventMaybeClose',
}

export class OnPackagePanelClose extends CustomEvent<{}> {
  constructor() {
    super(PackagePanelEvents.OnPackagePanelClose, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}

export class OnPackagePanelMaybeClose extends CustomEvent<{}> {
  constructor() {
    super(PackagePanelEvents.OnPackagePanelMaybeClose, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
